import { mapLines } from "./lines";

// A slug is built with hyphens whatever it is asked to end in: every separator is itself a character no slug keeps,
// so the swap at the end cannot run into one that was already there.
export function slugify(text: string, variant: string): string {
  const separator = variant === "underscore" ? "_" : "-";
  return mapLines(text, (line) => {
    const spelled = [...line.toLowerCase()].map((character) => SPELLED[character] ?? character).join("");
    return spelled
      .normalize("NFKD")
      .replace(/\p{M}+/gu, "")
      .replace(/[^\p{L}\p{N}]+/gu, "-")
      .replace(/^-+|-+$/g, "")
      .replaceAll("-", separator);
  });
}

// Letters no decomposition takes apart, each spelled the way the language that writes it spells it out loud.
const SPELLED: Record<string, string> = {
  "ß": "ss",
  "æ": "ae",
  "œ": "oe",
  "ø": "o",
  "đ": "d",
  "ð": "d",
  "þ": "th",
  "ł": "l",
  "ı": "i",
};
